import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconMagnifyingGlassDollar = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 17 17",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#a)",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M8.5 17a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17Zm.69-12.564v.471c.323.04.645.13.963.22.064.016.123.033.186.053a.718.718 0 0 1-.381 1.384c-.05-.013-.103-.03-.156-.043a8.644 8.644 0 0 0-.701-.176 2.418 2.418 0 0 0-1.355.133c-.365.16-.667.544-.252.81.325.21.724.316 1.102.418.08.02.156.044.233.064.518.146 1.178.335 1.673.674.644.441.946 1.158.804 1.929-.136.743-.654 1.232-1.275 1.484a3.12 3.12 0 0 1-.837.206v.504a.718.718 0 0 1-.717.718.718.718 0 0 1-.717-.718v-.577c-.482-.11-.953-.263-1.422-.415a.716.716 0 1 1 .452-1.362c.083.027.166.057.25.083.374.127.76.256 1.145.319.564.083 1.016.033 1.311-.086.399-.16.588-.634.196-.9-.335-.23-.75-.342-1.146-.448-.076-.02-.149-.04-.225-.063-.502-.143-1.13-.32-1.6-.621-.648-.415-.977-1.106-.837-1.873.132-.724.697-1.205 1.295-1.464.182-.08.378-.143.58-.19v-.534a.718.718 0 0 1 1.435 0H9.19Z"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h17v17H0z"
		})
	}) })]
});
export default SvgIconMagnifyingGlassDollar;
